import { render, staticRenderFns } from "./ServiceDoc.vue?vue&type=template&id=25494ebc&scoped=true"
import script from "./ServiceDoc.vue?vue&type=script&lang=js"
export * from "./ServiceDoc.vue?vue&type=script&lang=js"
import style0 from "./ServiceDoc.vue?vue&type=style&index=0&id=25494ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25494ebc",
  null
  
)

export default component.exports